import React from 'react';

import { Input, Tag } from "antd";
import { useTranslation } from "react-i18next";

export const FiltersTab = (props: any) => {

    const { t } = useTranslation();
    let {
        categories = [],

        tags = [],
        usedTags = [],
        tagFilter = [],

        likelihoods = [],
        likelihoodFilter = [],

        impacts = [],
        impactFilter = [],

        stakeholders = [],
        stakeholderFilter = [],

        stakes = [],
        stakeFilter = []
    } = props;

    impacts = impacts || [];
    likelihoods = likelihoods || [];

    return (
        <div className="FiltersTab">
            <Input
                onChange={(e) => {
                    props.setSearchTerm(e.target.value);
                }}
                value={props.searchTerm}

                placeholder={t('messages.search')}
                className="SearchInput w-100 mt-05"
            ></Input>

            <strong
                className="text-left mt-2"
                style={{ marginBottom: '0.5rem' }}
            >
                {t('pages.navigator.all_tags')}
            </strong>
            <div className="text-left" style={{ marginBottom: '0.5rem' }}>
                {tags.length === 0 ? (
                    <div style={{ color: 'var(--ant-color-text-tertiary)', fontSize: '0.85rem' }}>
                        {t('pages.navigator.no_tag')}
                    </div>
                ) : (
                    tags.map((tag, index) => (
                        <Tag.CheckableTag
                            key={'tag' + index}
                            checked={tagFilter.includes(tag.id)}
                            onClick={() => {
                                tagFilter.includes(tag.id)
                                    ? props.setTagFilter(tagFilter.filter(id => id !== tag.id))
                                    : props.setTagFilter([...tagFilter, tag.id]);
                            }}
                            className="tag"
                        >
                            {tag.name}
                        </Tag.CheckableTag>
                    ))
                )}
            </div>

            <strong
                className="text-left mt-2"
                style={{ marginBottom: '0.5rem' }}
            >
                {t('pages.risks.all_categories')}
            </strong>

            <div className="text-left">
                {categories.map((t, index) => (
                    <Tag.CheckableTag
                        key={'t' + index}
                        checked={props.categoryFilter.includes(t.id)}
                        onClick={() => {
                            // Add filter if not present, remove it if already present
                            props.categoryFilter.includes(t.id)
                                ? props.setCategoryFilter(
                                    props.categoryFilter.filter(
                                        (category) =>
                                            category !==
                                            t.id
                                    )
                                )
                                : props.setCategoryFilter([
                                    ...props.categoryFilter,
                                    t.id
                                ]);
                            //tagFilter == t ? setTagFilter(null) : setTagFilter(t)
                        }}
                        className={[
                            'tag'
                        ].join(' ')}
                    >
                        {t.name || t.id}
                    </Tag.CheckableTag>
                ))}
            </div>


            <strong
                className="text-left mt-2"
                style={{ marginBottom: '0.5rem' }}
            >
                {t('pages.risks.all_impacts')}
            </strong>

            <div className="text-left">
                {impacts.map((t, index) => (
                    <Tag.CheckableTag
                        key={'t' + index}
                        checked={impactFilter.includes(t.id)}
                        onClick={() => {
                            // Add filter if not present, remove it if already present
                            impactFilter.includes(t.id)
                                ? props.setImpactFilter(
                                    impactFilter.filter(
                                        (category) =>
                                            category !==
                                            t.id
                                    )
                                )
                                : props.setImpactFilter([
                                    ...impactFilter,
                                    t.id
                                ]);
                            //tagFilter == t ? setTagFilter(null) : setTagFilter(t)
                        }}
                        className={[
                            'tag'
                        ].join(' ')}
                    >
                        {t.name || t.id}
                    </Tag.CheckableTag>
                ))}
            </div>

            <strong
                className="text-left mt-2"
                style={{ marginBottom: '0.5rem' }}
            >
                {t('pages.risks.all_likelihoods')}
            </strong>

            <div className="text-left">
                {likelihoods.map((t, index) => (
                    <Tag.CheckableTag
                        key={'t' + index}
                        checked={likelihoodFilter.includes(t.id)}
                        onClick={() => {
                            // Add filter if not present, remove it if already present
                            likelihoodFilter.includes(t.id)
                                ? props.setLikelihoodFilter(
                                    likelihoodFilter.filter(
                                        (category) =>
                                            category !==
                                            t.id
                                    )
                                )
                                : props.setLikelihoodFilter([
                                    ...likelihoodFilter,
                                    t.id
                                ]);
                            //tagFilter == t ? setTagFilter(null) : setTagFilter(t)
                        }}
                        className={[
                            'tag'
                        ].join(' ')}
                    >
                        {t.name || t.id}
                    </Tag.CheckableTag>
                ))}
            </div>

            <strong
                className="text-left mt-2"
                style={{ marginBottom: '0.5rem' }}
            >
                {t('pages.risks.all_stakes')}
            </strong>

            {
                stakes.length == 0 ? (
                    <div
                        className="text-center"
                        style={{
                            color: 'var(--ant-color-text-tertiary)'
                        }}
                    >
                        {t('models.stake.no_x')}
                    </div>
                ) : (
                    <div className="text-left FilterStakes">
                        {stakes.map((t, index) => (
                            <Tag.CheckableTag
                                key={'t' + index}
                                checked={stakeFilter.includes(t.id)}
                                onClick={() => {
                                    // Add filter if not present, remove it if already present
                                    stakeFilter.includes(t.id)
                                        ? props.setStakeFilter(
                                            stakeFilter.filter(
                                                (tag) =>
                                                    tag !==
                                                    t.id
                                            )
                                        )
                                        : props.setStakeFilter([
                                            ...stakeFilter,
                                            t.id
                                        ]);
                                    //indicatorFilter == t ? setStakeholderFilter(null) : setStakeholderFilter(t)
                                }}
                                className={[
                                    'tag'
                                ].join(' ')}
                            >
                                {t.name}
                            </Tag.CheckableTag>
                        ))}
                    </div>
                )
            }

            <strong
                className="text-left mt-2"
                style={{ marginBottom: '0.5rem' }}
            >
                {t('pages.risks.all_stakeholders')}
            </strong>

            {
                stakeholders.length == 0 ? (
                    <div
                        className="text-center"
                        style={{
                            color: 'var(--ant-color-text-tertiary)'
                        }}
                    >
                        {t('models.item.no_x')}
                    </div>
                ) : (
                    <div className="text-left">
                        {stakeholders.map((t, index) => (
                            <Tag.CheckableTag
                                key={'t' + index}
                                checked={stakeholderFilter.includes(t.id)}
                                onClick={() => {
                                    // Add filter if not present, remove it if already present
                                    stakeholderFilter.includes(t.id)
                                        ? props.setStakeholderFilter(
                                            stakeholderFilter.filter(
                                                (tag) =>
                                                    tag !==
                                                    t.id
                                            )
                                        )
                                        : props.setStakeholderFilter([
                                            ...stakeholderFilter,
                                            t.id
                                        ]);
                                    //stakeholderFilter == t ? setStakeholderFilter(null) : setStakeholderFilter(t)
                                }}
                                className={[
                                    'tag'
                                ].join(' ')}
                            >
                                {t.name}
                            </Tag.CheckableTag>
                        ))}
                    </div>
                )
            }
        </div >
    );
}